// extracted by mini-css-extract-plugin
export var card = "_8t-1";
export var container = "_8t-0";